import "./privacyPage.css";

const PrivacyPage = () => (
  <main className="legal-section">
    <div className="legal-container">
      <h1 className="legal-title">Privacy Policy</h1>
      <p className="legal-updated">Last updated: January 2025</p>

      <section className="legal-block">
        <h2>1. Introduction</h2>
        <p>
          Tshwane University of Technology (TUT) is committed to protecting the
          privacy and personal information of all users of the TUT ReportHub
          system. This Privacy Policy explains how we collect, use, store, and
          protect your personal data in accordance with applicable data
          protection legislation.
        </p>
      </section>

      <section className="legal-block">
        <h2>2. Information We Collect</h2>
        <p>We collect the following personal information when you use TUT ReportHub:</p>
        <ul>
          <li>Full name and surname</li>
          <li>Institutional email address</li>
          <li>Staff number</li>
          <li>Contact number (if provided)</li>
          <li>Department and module assignments</li>
          <li>Profile picture (if uploaded)</li>
          <li>Report content, including weekly activities, attendance data, and attached files</li>
          <li>System activity logs (login times, actions performed)</li>
        </ul>
      </section>

      <section className="legal-block">
        <h2>3. How We Use Your Information</h2>
        <p>Your personal information is used solely for the following purposes:</p>
        <ul>
          <li>To authenticate your identity and manage access to the system.</li>
          <li>To facilitate the submission, review, and management of weekly lecturer reports.</li>
          <li>To send automated reminders and notifications about report deadlines.</li>
          <li>To generate statistics and reports for departmental oversight.</li>
          <li>To maintain an audit trail of system activity for security and accountability purposes.</li>
        </ul>
      </section>

      <section className="legal-block">
        <h2>4. Data Storage and Security</h2>
        <p>
          Your data is stored securely on institutional servers. We implement
          appropriate technical and organisational measures to protect your
          personal information against unauthorised access, disclosure,
          alteration, or destruction. Passwords are encrypted and never stored
          in plain text.
        </p>
      </section>

      <section className="legal-block">
        <h2>5. Data Sharing</h2>
        <p>
          Your personal information is not sold, rented, or shared with any
          third parties outside of the university. Within the institution, access
          to your information is restricted to authorised personnel (e.g.,
          reviewers and administrators) on a need-to-know basis for the purposes
          outlined in this policy.
        </p>
      </section>

      <section className="legal-block">
        <h2>6. Data Retention</h2>
        <p>
          Personal information and submitted reports are retained for as long as
          necessary to fulfil the purposes described in this policy, or as
          required by applicable law and institutional policies. When data is no
          longer needed, it is securely deleted or anonymised.
        </p>
      </section>

      <section className="legal-block">
        <h2>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you.</li>
          <li>Request correction of inaccurate or incomplete data.</li>
          <li>Request deletion of your data, subject to institutional record-keeping requirements.</li>
          <li>Object to or restrict the processing of your personal information in certain circumstances.</li>
        </ul>
        <p>
          To exercise any of these rights, please contact the system
          administrator via the <a href="/contact-us">Contact Us</a> page.
        </p>
      </section>

      <section className="legal-block">
        <h2>8. Cookies</h2>
        <p>
          TUT ReportHub uses secure, HttpOnly cookies for authentication
          purposes. These cookies are essential for the operation of the system
          and are not used for tracking or advertising. By using the system, you
          consent to the use of these essential cookies.
        </p>
      </section>

      <section className="legal-block">
        <h2>9. Changes to This Policy</h2>
        <p>
          This Privacy Policy may be updated from time to time. Any changes will
          be posted on this page with an updated revision date. Continued use of
          the system after changes are made constitutes your acceptance of the
          revised policy.
        </p>
      </section>

      <section className="legal-block">
        <h2>10. Contact</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy or how
          your data is handled, please contact us via the{" "}
          <a href="/contact-us">Contact Us</a> page.
        </p>
      </section>
    </div>
  </main>
);

export default PrivacyPage;
